import axios from "axios";
import Swal from "sweetalert2";
import { Toast } from "../layout/Alerta";
import { logoutapp, validateSession } from "./Validation";


export function base64ToArrayBuffer(data: string) {
  var bString = window.atob(data);
  var bLength = bString.length;
  var bytes = new Uint8Array(bLength);
  for (var i = 0; i < bLength; i++) {
    var ascii = bString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

export const SaveFile2 = async (Data: any, Url: string): Promise<Boolean> => {
  var data = await axios({
    method: "post",
    url: process.env.REACT_APP_APPLICATION_ENDPOINT + Url,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: localStorage.getItem("jwtToken") || "",
    },
    data: Data,
  })
    .then(function (response) {
      Toast.fire({
        icon: "success",
        title: "¡Registro creado con éxito!",
      });
      return true;
    })
    .catch(function (error) {
      if (error.response?.status) {
        if (error.response?.status === 401) {
          logoutapp();
          return false;
        }
      }
      Swal.fire({
        icon: "error",
        title: "¡Error!",
        html: "(" + error.response?.status + ") " + error.response?.data?.message,
        confirmButtonColor: "#15212f",
      });
      return false;
    });
  return data;
};

export const SaveFile = async (Data: any, Url: string): Promise<any> => {
  var formData = new FormData();
  Object.keys(Data).forEach((fieldName) => {
    if (fieldName === "multipleFiles") {
      for (var x = 0; x < Data[fieldName].length; x++) {
        formData.append("multipleFiles[]", Data[fieldName][x]);
      }
    } else if (fieldName === "inmuebles") {
      for (var y = 0; y < Data[fieldName].length; y++) {
        formData.append("inmuebles[]", Data[fieldName][y]);
      }
    } else {
      formData.append(fieldName, Data[fieldName]);
    }
  });
  var data = await axios({
    method: "post",
    url: process.env.REACT_APP_APPLICATION_ENDPOINT + Url,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: localStorage.getItem("jwtToken") || "",
    },
    data: formData,
  })
    .then(function (response) {
      /*Toast.fire({
        icon: "success",
        title: "¡Registro creado con éxito!",
      });*/
      return response.data;
    })
    .catch(function (error) {
      if (error.response?.status) {
        if (error.response?.status === 401) {
          logoutapp();
          return false;
        }
      }
      Swal.fire({
        icon: "error",
        title: "¡Error!",
        html: "(" + error.response?.status + ") " + error.response?.data?.message,
        confirmButtonColor: "#15212f",
      });
      return false;
    });
  return data;
};

export const catalogoSave = async (
  Data: any,
  Url: string
): Promise<boolean> => {
  const result = await axios({
    method: "POST",
    url: process.env.REACT_APP_APPLICATION_ENDPOINT + Url,
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("jwtToken") || "",
    },
    data: Data,
  })
    .then(function (response) {
      Toast.fire({
        icon: "success",
        title: "¡Registro creado con éxito!",
      });
      return true;
    })
    .catch(function (error) {
      if (error.response?.status) {
        if (error.response?.status === 401) {
          logoutapp();
          return false;
        }
      }
      Swal.fire({
        icon: "error",
        title: "¡Error!",
        html:
          "(" +
          error.response?.status +
          ") " +
          error.response?.data?.message +
          " ",
        confirmButtonColor: "#15212f",
      });
      return false;
    });
  return result;
};

export const catalogoUpdate = async (
  Data: any,
  Url: string
): Promise<boolean> => {
  const response = await axios({
    method: "PUT",
    url: process.env.REACT_APP_APPLICATION_ENDPOINT + Url + "/" + Data.uuid,
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("jwtToken") || "",
    },
    data: Data,
  })
    .then(function (response) {
      Toast.fire({
        icon: "success",
        title: "¡Registro actualizado con éxito!",
      });
      return true;
    })
    .catch(function (error) {
      if (error.response?.status) {
        if (error.response?.status === 401) {
          logoutapp();
          return false;
        }
      }
      Swal.fire({
        icon: "error",
        title: "¡Error!",
        html: "(" + error.response?.status + ") " + error.response?.data?.message,
        confirmButtonColor: "#15212f",
      });
      return false;
    });
  return response;
};
export const catalogoDelete = async (
  Data: any,
  Url: string,
  Descripcion: string
): Promise<boolean> => {
  const response = await Swal.fire({
    title: "¿Estas Seguro(a) de eliminar este registro? ",
    text: `${Descripcion}`,
    // text                : `Estas a punto de eliminar un registro (${Descripcion})`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Eliminar",
    confirmButtonColor: "#15212f",
    cancelButtonColor: "#bda889",
    cancelButtonText: "Cancelar",
  }).then(async (result) => {
    if (result.isConfirmed) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("jwtToken") || "",
      };
      const data = Data;
      const url =
        process.env.REACT_APP_APPLICATION_ENDPOINT + Url + "/" + Data.uuid;
      const info = await axios
        .delete(url, { headers, data })
        .then(function (response) {
          Toast.fire({
            icon: "success",
            title: "¡Registro eliminado con éxito!",
          });
          return true;
        })
        .catch(function (error) {
          if (error.response?.status) {
            if (error.response?.status === 401) {
              logoutapp();
              return false;
            }
          }
          Swal.fire({
            icon: "error",
            title: "¡Error!",
            html:
              "(" +
              error.response?.status +
              ") " +
              error.response?.data?.message,
            confirmButtonColor: "#15212f",
          });
          return false;
        });
      return info;
    } else {
      return false;
    }
  });
  return response !== undefined ? true : false;
};
type PageType = {
  perPage: number;
  currentPage: number;
  proceso: number;
};
export const catalogoList: any = async (
  Url: string,
  Pagination?: Boolean,
  PageData?: PageType,
  Search?: Boolean,
  SearchText?: string
) => {
  const userRoles = JSON.parse(localStorage.getItem("Roles")!) || [];
  var FinalUrl = Url;
  if (Pagination || Search) {
    FinalUrl = Url + "?";
  }
  if (Pagination) {
    FinalUrl += "perpage=" + PageData?.perPage;
    FinalUrl += "&page=" + PageData?.currentPage;
    FinalUrl += "&Rol=" + userRoles[0].ControlInterno || "";
    FinalUrl += "&PROCES0=" + PageData?.proceso || "";
  }
  if (Search) {
    FinalUrl += Pagination ? "&search=" : "search=";
    FinalUrl += SearchText;
  }
  const response = await axios({
    method: "get",
    url: process.env.REACT_APP_APPLICATION_ENDPOINT + FinalUrl,
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("jwtToken") || "",
    },
  })
    .then(async (response) => {
      await validateSession();
      return response.data;
    })
    .catch(function (error) {
      if (error.response?.status) {
        if (error.response?.status === 401) {
          logoutapp();
          return false;
        }
      }
      Swal.fire({
        icon: "error",
        title: "¡Error!",
        html: "(" + error.response?.status + ") " + error.response?.data?.message,
        confirmButtonColor: "#15212f",
      });
      return false;
    });
  return response;
};

export const getFile = async (Data: any, Url: string): Promise<any> => {
  const url =
    process.env.REACT_APP_APPLICATION_ENDPOINT +
    Url +
    "/" +
    Data.uuid +
    "/" +
    localStorage.getItem("jwtToken");
  axios({
    url: url,
    method: "GET",
    responseType: "blob", // important
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", Data.Nombre);
    document.body.appendChild(link);
    link.click();
  });
};

export const handleFile = async function (url: string, body: any) {
  let rs;
  try {
    let resp = await axios.post(
      process.env.REACT_APP_APPLICATION_ENDPOINT + url,
      body,
      {
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "Access-Control-Allow-Origin": "*",
          Authorization: localStorage.getItem("jwtToken") || "",
        },
      }
    );
    rs = {
      RESPONSE: resp.data.RESPONSE,
      SUCCESS: resp.data.SUCCESS,
      NUMCODE: resp.data.NUMCODE,
      STRMESSAGE: resp.data.STRMESSAGE,
    };

    return rs;
  } catch (err: any) {
    return false;
  }
};

export const updateSimple = async (Data: any, Url: string): Promise<any> => {
  var formData = new FormData();
  Object.keys(Data).forEach((fieldName) => {
    formData.append(fieldName, Data[fieldName]);
  });
  var data = await axios({
    method: "post",
    url: process.env.REACT_APP_APPLICATION_ENDPOINT + Url,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: localStorage.getItem("jwtToken") || "",
    },
    data: formData,
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
  return data;
};
